import getUrlFromRequest from './getUrlFromRequest';
import getPrefix from './getPrefix';
import windowUrl from './windowUrl';
import redirectToRoute from './redirectToRoute';

const correctPrefix = ({
  req, res, query, pathname,
}) => {
  const url = req ? getUrlFromRequest(req) : windowUrl;
  const prefix = getPrefix(url);

  if (!/\/fr$/.test(prefix)
    && (/\/\/[^/]+\/fr(\/|$)/.test(url) || query.prefix === 'fr')) {
    const { prefix: _, ...queryWithoutPrefix } = query;
    redirectToRoute(pathname, queryWithoutPrefix, res);
  }
};

export default correctPrefix;
